import React from 'react'

import { Divider as DividerBase, Grid as GridBase, styled } from '@mui/material'
import { ArrowDownward as ArrowDownwardBase, Error as ErrorBase, Work as WorkBase } from '@mui/icons-material'
import { Tag as TagBase, Card as CardBase } from '@chilecompra/react-kit/components'

export const Divider = styled(DividerBase)``

export const DownloadLink = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  margin: auto 0 auto auto;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    visibility: ${props => props.visibility};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`

export const ArrowDownwardIcon = styled(ArrowDownwardBase)`
  color: ${props => props.theme.palette.blue[50]};
  margin: ${props => props.margin};
`

export const WorkIcon = styled(WorkBase)`
  &.MuiSvgIcon-root {
    fill: ${props => (props.color === 'blue' ? props.theme.palette.blue[50] : props.theme.palette.gray[75])};
    font-size: 1.2rem;
    margin: ${props => props.margin};
  }
`

export const ExclamationIcon = styled(ErrorBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.primary};
    font-size: 1.2rem;
    margin: ${props => props.margin};
  }
`

export const TooltipText = styled('span')`
  margin: 0;
`

export const Strong = styled('strong')``

export const LinkLabel = styled('div')`
  color: ${props => (props.color === 'blue' ? props.theme.palette.blue[50] : props.theme.palette.gray[75])};
  cursor: ${props => props.pointer && 'pointer'};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
`
export const DivIcon = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: rgba(0, 123, 255, 0.1);
  border-radius: 50%;
`

export const LinkDate = styled('div')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
`

export const Root = styled('div')`
  width: 100%;
`

export const Row = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
`

export const LetterBlue = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: ${props => props.pointer && 'pointer'};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const LetterAbilityAffidavit = styled('a')`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
`

export const LetterDeclarationInadmissibility = styled('a')`
  color: ${props => props.theme.palette.red[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;
`

export const WrapperCustomCard = styled('div')`
  ${props => props.theme.breakpoints.up('sm')} {
    position: absolute;
    width: 272px;
    z-index: 1000;
    right: 1%;
  }
  ${props => props.theme.breakpoints.up('md')} {
    right: 3%;
  }
  margin-top: ${props => (props.firstRow ? '2%' : '-1%')};
`

export const Card = styled(({ active, ...props }) => <CardBase {...props} />)`
  &.MuiPaper-root {
    border: 1px solid ${props => (props.active ? props.theme.palette.brand.success : props.theme.palette.brand.gray2)};
  }
`
export const DialogWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px;
`
export const Tag = styled(TagBase)`
  &.MuiPaper-root {
    display: inline-flex;
  }
`
export const Label = styled('div')`
  background-color: ${props => props.theme.palette.gray[90]};
  color: ${props => props.theme.palette.brand.black2};
  font-size: 10px;
  text-transform: none;
  padding: 10px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 5px;
  line-height: 10px;
  font-weight: 400;
  padding-top: 5px;
  padding-bottom: 5px;
`
